import React from "react";
import * as CHQ from "chq";

import { Trans } from "app/utils";
import { PlainButton } from "@culturehq/components";
import { makePost } from "@culturehq/client";
import NotificationBody from "./NotificationBody";

type ProcessingStoryErrorNotificationProps = {
  notification: CHQ.NotificationProcessingStoryError;
  tabIndex?: number;
};

type Actions = {
  handleRetryAction: () => {};
};

const getMessageType = ({ withCallToAction = false }: CHQ.ThirdPartyMediaMetadata = {}) => (withCallToAction ? "retryAction" : "onlySupport");

const messages = ({ handleRetryAction }: Actions) => ({
  onlySupport: () => <>Your story update failed, please contact support to help you</>,
  retryAction: () => (
    <>
      Your story update failed, please
      {" "}<PlainButton onClick={handleRetryAction}>try again</PlainButton>{" "}
      or contact support to help you
    </>
  )
});

const ProcessingStoryErrorNotification: React.FC<ProcessingStoryErrorNotificationProps> = ({
  notification: { entity }
}) => {
  const handleRetryAction = () => makePost("/creatomate_media/retries", { id: entity.thirdPartyRenderId });

  const messageType = getMessageType(entity?.metadata);
  const Message = messages({ handleRetryAction })[messageType];

  const actor = {
    name: entity?.creator?.name || entity?.name,
    avatar: entity?.creator?.avatar || entity?.avatar
  };

  return (
    <NotificationBody actor={actor}>
      <Trans><Message /></Trans>
      <br />
    </NotificationBody>
  );
};

export default ProcessingStoryErrorNotification;
